import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class CorpList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        yearsConData: PropTypes.string,
    };

    constructor(props) {
        super(props);

        const { content } = this.props;

        this.state = {
            contentData: content.ContentData2019,
        };
    }

    componentDidMount() {
        this.createChannelInfo();
    }

    componentDidUpdate(prevProps) {
        if (this.props.yearsConData !== prevProps.yearsConData) {
            this.createChannelInfo();
        }
    }

    createChannelInfo = () => {
        const { content, yearsConData } = this.props;

        if (yearsConData === '285146') {
            this.setState({
                contentData: content.ContentData2021,
            });
        } else if (yearsConData === '285145') {
            this.setState({
                contentData: content.ContentData2020,
            });
        } else if (yearsConData === '285134') {
            this.setState({
                contentData: content.ContentData2019,
            });
        } else if (yearsConData === '285135') {
            this.setState({
                contentData: content.ContentData2018,
            });
        } else if (yearsConData === '285136') {
            this.setState({
                contentData: content.ContentData2017,
            });
        } else if (yearsConData === '285137') {
            this.setState({
                contentData: content.ContentData2016,
            });
        } else if (yearsConData === '285138') {
            this.setState({
                contentData: content.ContentData2015,
            });
        } else if (yearsConData === '285139') {
            this.setState({
                contentData: content.ContentData2014,
            });
        } else if (yearsConData === '285140') {
            this.setState({
                contentData: content.ContentData2013,
            });
        } else if (yearsConData === '285141') {
            this.setState({
                contentData: content.ContentData2012,
            });
        } else if (yearsConData === '285142') {
            this.setState({
                contentData: content.ContentData2011,
            });
        } else if (yearsConData === '285143') {
            this.setState({
                contentData: content.ContentData2010,
            });
        } else if (yearsConData === '285144') {
            this.setState({
                contentData: content.ContentData2009,
            });
        }
    };

    render() {
        const { contentData } = this.state;

        return (
            <div className={styles.newsLinks}>
                <table style={{ width: 788, cellpadding: 5, cellspacing: 5 }}>
                    <tbody>
                        {contentData.map((item, index) => {
                            return (
                                <div key={index}>
                                    <tr>
                                        <td className={styles.bg}>&nbsp;</td>
                                        <td>
                                            <a href={item.url} title={index}>
                                                {item.title}
                                            </a>
                                        </td>
                                    </tr>
                                    <br />
                                </div>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default CorpList;
